import { render, staticRenderFns } from "./BandBannerListPage.vue?vue&type=template&id=87838f82&"
import script from "./BandBannerListPage.vue?vue&type=script&lang=js&"
export * from "./BandBannerListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports